import React, { useMemo } from 'react';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import Field from '../../../../../modules/react/components/stateful/Field';
import classes from './section.scss';
import Input from '../../../../../modules/react/components/stateful/Input';
import {
  detectVideoSource,
  parseIFrame, // Import the parseIFrame function
} from '../../../utils/videoUtils';


const EmbedVideoSettings = (props) => {
  const { updateField, tabbedModalName } = props;

  const requiredAltText = useMemo(() => value => (value ? undefined : 'Alt Text is Required'), []);

  const validateVideoURL = useMemo(() => (value) => {
    if (value) {
      const videoSource = detectVideoSource(value);
      if (videoSource === 'youtube' || videoSource === 'vimeo') {
        return undefined;
      }
      return 'Invalid Video URL';
    }
    return 'Video URL is Required';
  }, []);

  const validateVideoEmbedCode = useMemo(() => (value) => {
    if (value) {
      const videoSource = detectVideoSource(value);
      if (videoSource === 'youtube' || videoSource === 'vimeo') {
        return undefined;
      }
      return 'Invalid Video Embed Code';
    }
    return undefined;
  }, []);

  const embedCodeChangeHandler = (e) => {
    const videoData = parseIFrame(e.target.value);
    updateField(tabbedModalName, 'sectionStyle.backgroundVideoURL', videoData.src);
    updateField(tabbedModalName, 'sectionStyle.backgroundVideoAltText', videoData.title);
    updateField(tabbedModalName, 'sectionStyle.backgroundVideoTitleText', videoData.title);
  };

  return (
    <div>
      <h4 className={classes.menuHeading}>Quick Start - Paste Your Video Embed Code</h4>
      <p className={classes.embedCodeHeading}>
        {
          ['Paste an embed code from YouTube or Vimeo to configure the video',
            'settings below. Alternatively you can configure these settings manually.',
          ].join(' ')}
      </p>
      <Field
        component={Input}
        componentClass="textarea"
        name="sectionStyle.backgroundVideoEmbedCode"
        labelClassName={classes.fieldLabelClass}
        className={classes.textAreaClass}
        validate={[validateVideoEmbedCode]}
        onChange={embedCodeChangeHandler}
      />
      <Field
        label="Video URL"
        component={Input}
        type="text"
        name="sectionStyle.backgroundVideoURL"
        labelClassName={classes.fieldLabelClass}
        className={classes.inputFieldClass}
        required
        // eslint-disable-next-line max-len
        tooltip="Add a URL from YouTube or Vimeo to display your video. We recommend using the embed URL to pre-populate the fields below."
        tooltipOnRight
        controlLabelClass={classes.controlLabelClass}
        validate={[validateVideoURL]}
      />
      <Field
        label="Alt Text"
        component={Input}
        id="videoEmbed-altText"
        type="text"
        name="sectionStyle.backgroundVideoAltText"
        labelClassName={classes.fieldLabelClass}
        className={classes.inputFieldClass}
        required
        // eslint-disable-next-line max-len
        tooltip="Alt text helps search engines better crawl and rank your website and also allows screen-reading tools to describe images and videos to visually impaired readers."
        tooltipOnRight
        controlLabelClass={classes.controlLabelClass}
        validate={[requiredAltText]}
      />
      <Field
        label="Title Text"
        component={Input}
        type="text"
        name="sectionStyle.backgroundVideoTitleText"
        labelClassName={classes.fieldLabelClass}
        className={classes.inputFieldClass}
        tooltip="Title text is used to provide additional information about the video."
        tooltipOnRight
        controlLabelClass={classes.controlLabelClass}
      />
    </div>
  );
};

const mapDispatchToProps = {
  updateField: (formname, field, data) => change(formname, field, data),
};


export default connect(null, mapDispatchToProps)(EmbedVideoSettings);
